/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Padding_Aria_LabelInputs */

const en_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padding`)
};

const fr_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplissage`)
};

const de_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polsterung`)
};

const it_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imbottitura`)
};

const ru_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Набивка`)
};

const es_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relleno`)
};

const zh_cn2_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填充`)
};

const ja_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パディング`)
};

const hi_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गद्दी`)
};

const pt_pt2_styles_padding_aria_label = /** @type {(inputs: Styles_Padding_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acolchoamento`)
};

/**
* | output |
* | --- |
* | "Padding" |
*
* @param {Styles_Padding_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_padding_aria_label = /** @type {((inputs?: Styles_Padding_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Padding_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_padding_aria_label(inputs)
	if (locale === "de") return de_styles_padding_aria_label(inputs)
	if (locale === "it") return it_styles_padding_aria_label(inputs)
	if (locale === "ru") return ru_styles_padding_aria_label(inputs)
	if (locale === "es") return es_styles_padding_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_padding_aria_label(inputs)
	if (locale === "ja") return ja_styles_padding_aria_label(inputs)
	if (locale === "hi") return hi_styles_padding_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_padding_aria_label(inputs)
	return en_styles_padding_aria_label(inputs)
});